import React, { FC, useCallback } from 'react';
import reject from 'lodash/reject';

import ConditionRow from './ConditionRow';
import { RoutingChannel, RoutingChannelCondition as RoutingChannelConditionType } from 'src/actions/rules/condition';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';
import { TriggerType } from 'src/actions/rules/trigger';

type RoutingChannelConditionProps = {
  condition: RoutingChannelConditionType;
  index: number;
  triggerType: TriggerType;
  onDelete: Function;
  onUpdate: Function;
};

const RoutingChannelCondition: FC<RoutingChannelConditionProps> = ({
  condition,
  index,
  triggerType,
  onDelete,
  onUpdate,
}) => {
  const onChannelChange = useCallback(
    val => {
      condition.setValue(val);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  if (triggerType === TriggerType.ConversationDueIn || triggerType === TriggerType.TopicsAdded) {
    channelOptions = reject(channelOptions, { value: RoutingChannel.Task });
  }
  return (
    <ConditionRow index={index} onDelete={onDelete} text="Channel Type is">
      <StyledDropdown
        onSelect={onChannelChange}
        options={channelOptions}
        placeholder="Select channel"
        value={condition.value}
      />
    </ConditionRow>
  );
};

let channelOptions: { label: string; value: string }[] = [
  { label: 'Mail', value: RoutingChannel.Mail },
  { label: 'Messaging', value: RoutingChannel.Messaging },
  { label: 'Task', value: RoutingChannel.Task },
  { label: 'Voice', value: RoutingChannel.Voice },
];

export default RoutingChannelCondition;
